@if (model) {
  <div class="stim-print-actions">
    <button
      pButton
      class="p-button-success p-button-outlined"
      (click)="print()"
    >
      {{ 'common.print' | translate }}
    </button>
    <label class="stim-print-toggle">
      <input
        type="checkbox"
        [checked]="showUltrasounds"
        (change)="onToggleUltrasounds()"
      />
      {{ 'ivf.stimulation-form.print-include-ultrasounds' | translate }}
    </label>
  </div>

  <div class="stim-print-preview">
    <app-stimulation-form-a4-print [model]="model" />
  </div>
}
